import { DateRangeMode } from '../components/validation/dateRangeModesConfig';

/**
 * Feature specific constants to limit what date ranges are visible.
 */
export const SPLIT_ORDER_INVOICES_DATE_RANGE_MODES: DateRangeMode[] = [
    'TODAY',
    'YESTERDAY',
    'TODAYYESTERDAY',
    '2DAYS',
    '3DAYS',
    '7DAYS',
    '2WEEKS',
    'MONTHLY',
    'MTD',
    'QTR',
    'QTD',
    'QTDLAST',
    'CUSTOM92',
];
export const CP_ORDER_INVOICES_DATE_RANGE_MODES: DateRangeMode[] = [
    'TODAY',
    'YESTERDAY',
    'TODAYYESTERDAY',
    '2DAYS',
    '3DAYS',
    '7DAYS',
    '2WEEKS',
    'MONTHLY',
    'MTD',
    'QTR',
    'QTD',
    'QTDLAST',
    'CUSTOM92',
];
export const FEEDS_FEATURE_DATE_RANGE_MODES: DateRangeMode[] = [
    'TODAY',
    'YESTERDAY',
    'TODAYYESTERDAY',
    '2DAYS',
    '3DAYS',
    '7DAYS',
    '2WEEKS',
    'MONTHLY',
    'MTD',
    'QTR',
    'QTD',
    'QTDLAST',
    'CUSTOM92',
];
export const FEEDS_FEATURE_LIMITED_DATE_RANGE_MODES: DateRangeMode[] = [
    'TODAY',
    'YESTERDAY',
    'TODAYYESTERDAY',
    '2DAYS',
    '3DAYS',
    'CUSTOM3',
];
